<template>
    <div class="page-container">
        <div class="page-container__header">
            <h1 class="header-1 page-container__title">Articolele mele ({{specialistArticles.length}})</h1>
        </div>
        <div class="page-container__body">
            <Card>
                <div class="specialist-articles">
                    <SpecialistArticle v-for="(article, i) in specialistArticles" :key="i" :title="article.title"
                        :imageUrl="article.image_url" :categories="article.categories" @click.native="goToArticle(article.  slug)" />
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
    import Card from '@/components/ui/Card.vue'
    import SpecialistArticle from './components/SpecialistArticle'

    import {
        mapActions
    } from 'vuex'
    import {
        mapGetters
    } from 'vuex'

    export default {
        components: {
            Card,
            SpecialistArticle
        },
        computed: {
            ...mapGetters({
                specialistArticles: 'articles/specialistArticles'
            })
        },
        methods: {
            ...mapActions({
                fetchSpecialistArticles: 'articles/fetchSpecialistArticles'
            }),
            goToArticle(slug) {
                this.$router.push(`/articles/${slug}`);
            }
        },
        mounted() {
            // await this.userId();
            this.fetchSpecialistArticles();
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/scss/pages/_specialist-articles.scss';
</style>